import * as reducers from './lib/reducers'
import { actions as sharedActions, actionTypes } from './lib/actions/src'
import * as assetLinkActions from './lib/actions/src/assetLink'
import * as amsActions from './lib/actions/src/ams'
import userServiceActions from './lib/actions/userService'
import selectors from './lib/selectors'

//Resource service
import resourceServiceActions from './lib/actions/src/resourceService'

import closedCaptionsActions from './lib/actions/src/closedCaptions'

import { UserServiceReducerInterface as _UserServiceReducerInterface } from './lib/reducers/src/user/defaultState'
import { WebcastReducerInterface as _WebcastReducerInterface, WebcastInterface as _WebcastInterface } from './lib/reducers/src/webcast/defaultState'
import { ChannelReducerDefaultState as _ChannelReducerDefaultState } from './lib/reducers/src/channel/defaultState'
import { UserServiceResponseInterface as _UserServiceResponseInterface, UserServiceType as _UserServiceType } from './lib/actions/userService/userServiceTypes'
import resourcesDefaultState, { FileProps, LinkProps, ResourcesProps, ResourcesInterface, ResourceStatusProps, SettingProps } from './lib/reducers/src/resources/defaultState'
import surveyDefaultState, { SurveyProps, SurveyItemProps } from './lib/reducers/src/survey/defaultState'
import closedCaptionsDefaultState from './lib/reducers/src/closedCaptions/defaultState'

import userDefaultState from './lib/reducers/src/user/defaultState'
import { defaultState as webcastDefaultState, defaultWebcast as webcastDefaultData } from './lib/reducers/src/webcast/defaultState'
import { defaultState as channelDefaultState } from './lib/reducers/src/channel/defaultState'
import surveyActions from './lib/actions/src/survey'

export type UserServiceReducerInterface = _UserServiceReducerInterface
export type WebcastReducerInterface = _WebcastReducerInterface
export type WebcastInterface = _WebcastInterface
export type ChannelReducerDefaultState = _ChannelReducerDefaultState
export type UserServiceResponseInterface = _UserServiceResponseInterface

export type { 
  FileProps,
  LinkProps,
  ResourcesProps,
  ResourcesInterface,
  ResourceStatusProps,
  SettingProps,
  SurveyProps,
  SurveyItemProps
}

const actions = {
  ...sharedActions,
  user: userServiceActions,
  resource: resourceServiceActions,
  survey: surveyActions,
  closedCaptions: closedCaptionsActions
}


export const DefaultState = {
  channel: channelDefaultState,
  user: userDefaultState,
  webcast: webcastDefaultState,
  resources: resourcesDefaultState,
  survey: surveyDefaultState,
  closedCaptions: closedCaptionsDefaultState
}

export const DefaultWebcastData = webcastDefaultData

export const Enum = {
  UserServiceType: _UserServiceType
}

export { reducers, actions, actionTypes, selectors, assetLinkActions, amsActions }
